<template>
  <canvas id="waves"></canvas>
</template>

<script>

export default {
  mounted () {
    const self = this

    var c = document.getElementById('waves')
    var ctx = c.getContext('2d')
    var cw = c.width = window.innerWidth * 1.2
    var ch = c.height = window.innerHeight

    var peakMaxH = 500
    var peakMaxV = 100

    var lines = []
    var lineWidth = 1
    var gradient = ctx.createLinearGradient(100, 0, cw - 100, 0)
    gradient.addColorStop(0, '#6E48AA')
    gradient.addColorStop(1, '#9D50BB')
    ctx.fillStyle = gradient
    var strokeColor = gradient // '#8A237D'
    var fillColor = 'rgba(255,255,255,0)'

    class WavyLine {
      constructor (ctx, width, vPos, animDuration) {
        this.ctx = ctx
        this.canvasWidth = width
        this.vertBasis = vPos
        this.animDuration = animDuration
        this.controls = {
          x1: 0,
          y1: vPos,
          x2: self.$anime.random(3 * width / 2 - peakMaxH, 3 * width / 2 + peakMaxH),
          y2: self.$anime.random(vPos - peakMaxV, vPos + peakMaxV)
        }
      }

      // Draw line along defined points
      drawLine () {
        this.ctx.beginPath()
        this.ctx.moveTo(0, ch)
        this.ctx.strokeStyle = strokeColor
        this.ctx.lineWidth = lineWidth
        this.ctx.fillStyle = fillColor

        // Draw curves
        this.ctx.bezierCurveTo(this.controls.x1, this.controls.y1, this.controls.x2, this.controls.y2, this.canvasWidth, this.vertBasis)

        this.ctx.lineTo(this.canvasWidth, ch)
        this.ctx.lineTo(0, ch)

        this.ctx.stroke()
        this.ctx.fill()
        this.ctx.closePath()
      }
    }

    addLine(0, 10)
    for (let i = 0; i < ch; i += 100) {
      addLine(ch - i, 10 + i / 100)
    }

    function addLine (vy, anim) {
      var el1 = new WavyLine(ctx, cw, vy, anim)

      var tlv = self.$anime.timeline({ loop: true, direction: 'alternate' })
      tlv.add({
        targets: el1.controls,
        duration: anim * 500,
        // x1: el1.controls.x1,
        // y1: el1.controls.y1, // self.$anime.random(el1.controls.y1, el1.controls.y1 - 400),
        x2: self.$anime.random(3 * el1.canvasWidth / 2 - peakMaxH, 3 * el1.canvasWidth / 2 + peakMaxH),
        y2: self.$anime.random(el1.vertBasis - peakMaxH, el1.vertBasis + peakMaxH),
        easing: 'easeInOutQuad',
        delay: self.$anime.stagger(200, { grid: [1, lines.length], from: 'center' })
      })

      lines.push(el1)
    }

    function drawAllLines () {
      // console.log("draw All Lines");
      ctx.clearRect(0, 0, cw, ch)
      for (var i = 0; i < lines.length; i++) {
        lines[i].drawLine()
      }
    }

    var render = function () {
      window.requestAnimationFrame(render, c)
      drawAllLines()
    }

    window.requestAnimFrame = (function () { return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (a) { window.setTimeout(a, 1E3 / 60) } }())

    render()
  }
}
</script>

<style lang="scss">

</style>
